module.exports = __webpack_public_path__ + "img/fayi_03.001e0d9c.jpg";